// extracted by mini-css-extract-plugin
export default {"modal":"SelectTemplate_modal__-1ZD1","tips":"SelectTemplate_tips__Orj7Q","count":"SelectTemplate_count__ykYuJ"};